import { AlertCircle, RefreshCw } from "lucide-react";
import SessionDetailsTable from "./SessionDetailsTable";
import JoinCallSection from "./JoinCallSection";

export default function SessionDetailsTab({ 
  userFlow, 
  slotData, 
  isSlotLoading, 
  slotError, 
  isRefreshing, 
  handleRefresh, 
  formatDate, 
  formatTime, 
  getPlatformName,
  copiedLink,
  copyToClipboard
}) {
  if (isSlotLoading) {
    return (
      <div className="text-center py-8">
        <div className="text-base font-normal text-muted-foreground">
          Loading session details...
        </div>
      </div>
    );
  }

  if (slotError) {
    return (
      <div className="text-center py-8">
        <AlertCircle className="mx-auto h-12 w-12 text-red-500 mb-4" />
        <div className="text-base font-normal text-red-500 mb-4">
          {slotError.response?.status === 404
            ? userFlow === 'remote' 
              ? "No session scheduled. Please contact support for assistance."
              : "No booking found. Please book a session to see your details here."
            : "Error loading session details. Please try again later."}
        </div>
        {userFlow === 'remote' && (
          <button
            onClick={handleRefresh}
            disabled={isRefreshing}
            className="inline-flex items-center px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50"
          >
            <RefreshCw className={`h-4 w-4 mr-2 ${isRefreshing ? 'animate-spin' : ''}`} />
            {isRefreshing ? 'Refreshing...' : 'Try Again'}
          </button>
        )}
      </div>
    );
  }

  if (!slotData) {
    return (
      <div className="text-center py-8">
        <div className="text-base font-normal text-muted-foreground">
          No session details available at the moment.
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Session Details Table - Same for both flows */}
      <SessionDetailsTable 
        slotData={slotData}
        userFlow={userFlow}
        formatDate={formatDate}
        formatTime={formatTime}
        getPlatformName={getPlatformName}
      />

      {/* Join Call Section - Only for Remote */}
      {userFlow === 'remote' && (
        <JoinCallSection 
          slotData={slotData}
          copiedLink={copiedLink}
          copyToClipboard={copyToClipboard}
        />
      )}
    </div>
  );
} 